import makeGriffinServiceRequest from '../../services/makeGriffinServiceRequest';
import {
    ADD_REMOVE_OR_EDIT_URL_PREFIX,
    SAVE_USER_EDITED_ENTITY_DATA,
} from '../../helpers/GriffinConstants';
import { MAX_LOADING_TIME } from '../../helpers/TxpConstants';
import GriffinServiceResponse from '../../store/schema/GriffinServiceResponse';
import { DatapointStatus } from 'owa-analytics';

/**
 * Handler for save editable Txp event
 */
export default function onSaveEditableCardClickHandler(
    itemId: string,
    requestBody: any,
    onServiceRequestError?: (statusCode: number, error?: string) => void
) {
    let timeoutPromise = new Promise<GriffinServiceResponse>(resolve => {
        setTimeout(resolve, MAX_LOADING_TIME, DatapointStatus.Timeout);
    });

    let griffinRequestPromise = makeGriffinServiceRequest(
        itemId,
        ADD_REMOVE_OR_EDIT_URL_PREFIX,
        SAVE_USER_EDITED_ENTITY_DATA,
        requestBody,
        onServiceRequestError
    );

    return Promise.race([timeoutPromise, griffinRequestPromise]);
}
